import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Typography,
  Avatar,
  TextField,
  InputAdornment,
  Tooltip,
  Chip,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useSupabaseAuth } from "contexts/SupabaseAuthContext";

const SettingsModal = ({ open, onClose }) => {
  const { currentUser } = useSupabaseAuth();
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(currentUser?.id || "");
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const getInitials = (email) => {
    if (!email) return "A";
    const parts = email.split("@")[0];
    return parts.charAt(0).toUpperCase();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          backgroundColor: (theme) => theme.palette.background.paper,
        },
      }}
    >
      <DialogTitle>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Typography variant="h6">Settings</Typography>
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{ color: (theme) => theme.palette.text.secondary }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ maxWidth: 600, mx: "auto" }}>
          <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
            <Avatar sx={{ width: 64, height: 64, mr: 2 }}>
              {getInitials(currentUser?.email)}
            </Avatar>
            <Box>
              <Typography variant="h6">{currentUser?.email}</Typography>
              <Chip label="Admin" color="primary" size="small" sx={{ mt: 1 }} />
            </Box>
          </Box>
          <TextField
            fullWidth
            label="User ID (UID)"
            value={currentUser?.id || ""}
            InputProps={{
              readOnly: true,
              endAdornment: (
                <InputAdornment position="end">
                  <Tooltip title={copied ? "Copied!" : "Copy to clipboard"}>
                    <IconButton onClick={handleCopy} edge="end">
                      <ContentCopyIcon />
                    </IconButton>
                  </Tooltip>
                </InputAdornment>
              ),
            }}
            sx={{ mb: 2 }}
          />
          <Typography variant="body2" color="text.secondary">
            Role: Admin
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default SettingsModal;
